import MainTable from './MainTable';
import TableHead from './TableHead';

const PageTable = { MainTable, TableHead };

export default PageTable;
